<div class="text-editor">
    <div [innerHTML]="block.data.text ? block.data.text : block.data.heading"></div>
    <div *ngIf="block.data.hasCustomLinks">
        <div class="custom-links">
            <div class="custom-link d-flex" *ngFor="let customLink of block.content; trackBy: trackByFn;">
                <div class="custom-link__image">
                    <img [src]="customLink.data.image | cdn" [alt]="customLink.data.linkText">
                </div>
                <div class="custom-link__content">
                    <a [href]="customLink.data.linkUrl">{{customLink.data.linkText}}</a>
                </div>
            </div>
        </div>
    </div>
</div>
